<template>
  <ModalView
    v-model="show"
    title="Letter Preview"
    size="lg"
    scrollable
    ok-title="Print"
    :disable-ok="previewItems.length === 0"
    @ok="onPrint"
    content-class="bg-light"
  >
    <LettersPreview
      v-if="previewItems.length"
      ref="letters"
      :items="previewItems"
      :include-screenshot="false"
    />
    <div v-else class="text-center p-4 text-muted">
      No previewable letters were found.
    </div>
    <div v-if="missingContextCount > 0" class="small text-warning text-center pb-2">
      {{ formatCount(missingContextCount, 'letter') }} could not be previewed because context was unavailable.
    </div>
  </ModalView>
</template>

<script>
import ModalView from "@/components/common/ModalView.vue";
import Correspondence from "@/models/Correspondence";
import LettersPreview from "@/components/letters/LettersPreview.vue";
import {buildLetterContextForCorrespondence, LetterContext} from "@/models/letterContext";
import printElement from "@/printElement";

export default {
  components: {LettersPreview, ModalView},
  emits: ['update:modelValue', 'print'],
  props: {
    modelValue: Boolean,
    items: {
      type: Array,
      default: null
    },
    letters: {
      type: Array,
      default: () => [],
      validator: (arr) =>
        Array.isArray(arr) && arr.every((x) => x instanceof Correspondence)
    },
    context: LetterContext,
    printOnOk: Boolean
  },
  computed: {
    show: {
      get() {
        return this.modelValue || false;
      },
      set(show) {
        this.$emit("update:modelValue", show);
      }
    },
    sourceItems() {
      if (Array.isArray(this.items)) {
        return this.items.filter(item => item?.letter instanceof Correspondence);
      }
      return (this.letters || []).map(letter => ({ letter, context: this.context || null }));
    },
    previewItems() {
      return this.sourceItems
        .map(item => {
          const context = item.context || buildLetterContextForCorrespondence(item.letter);
          if (!context?.city || !context?.property) {
            return null;
          }
          return {
            letter: item.letter,
            context
          };
        })
        .filter(Boolean);
    },
    missingContextCount() {
      return this.sourceItems.length - this.previewItems.length;
    }
  },
  methods: {
    printPreview() {
      if (!this.$refs.letters) {
        return;
      }
      printElement(this.$refs.letters);
    },
    onPrint() {
      if (this.printOnOk) {
        this.printPreview();
      }
      this.show = false;
      this.$emit('print');
    }
  }
}
</script>
